exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// /var/www/smartbuy.ru/~/babel-runtime/~/core-js/library/modules/_wks-ext.js
// module id = 629
// module chunks = 23 41